import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import PropTypes from 'prop-types';

import DealCard from '../DealCard/DealCard';

const SortableDealCard = ({ deal, onOpen }) => {
	const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
		id: deal.id,
		data: { type: 'deal', stageId: deal.stageId },
	});

	const style = {
		transform: CSS.Translate.toString(transform),
		opacity: isDragging ? 0.4 : undefined,
		zIndex: isDragging ? 0 : undefined,
	};

	return (
		<DealCard
			deal={deal}
			onOpen={onOpen}
			isDragging={isDragging}
			setNodeRef={setNodeRef}
			style={style}
			dragAttributes={attributes}
			dragListeners={listeners}
		/>
	);
};

SortableDealCard.propTypes = {
	deal: PropTypes.object.isRequired,
	onOpen: PropTypes.func,
};

export default SortableDealCard;
